module.exports = __webpack_public_path__ + "static/media/YF72_4.82b4ad31.jpg";